import gql from 'graphql-tag';

export const queries = {
    getIconCodeGenerationDataForTextPrompt: gql`
        query getIconCodeGenerationDataForTextPrompt($textPrompt: String!) {
            iconCodeGenerationData(textPrompt: $textPrompt) {
                score
                sidc
                tokensMatched
                tokensUnmatchedTextPrompt
                tokensUnmatchedMilSymbol
            }
        }
    `,
};

export const mutations = {};
